import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace NotificationValidation {
    export const Update = defineValidation(
        v.object({
            read: v.boolean(),
        }),
    );

    export const SendCustomer = defineValidation(
        v.object({
            title: baseVals.string(),
            message: baseVals.string(),
            imageURL: v.optional(baseVals.string()),
            customerId: baseVals.string(),
        }),
    );

    export namespace API {
        export const Record = defineValidation(BaseRecordSchema);
    }
}
